@if(employee) {
<!-- Two Column Layout: Profile Card + Personal Info -->
<div class="flex flex-col lg:flex-row gap-6">

  <!-- Left: Profile Summary Card -->
  <div class="w-full lg:w-80 shrink-0">
    <div class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden sticky top-6">
      <!-- Card Header with gradient -->
      <div class="h-20 bg-gradient-to-br from-blue-500 to-indigo-600 relative">
        <!-- Organization Badge -->
        <div class="absolute top-3 right-3">
          <span class="inline-flex items-center gap-1 text-xs bg-white/20 backdrop-blur-sm text-white px-2.5 py-1 rounded-full font-medium">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
            </svg>
            {{ getTenantNames() }}
          </span>
        </div>
      </div>

      <!-- Avatar (overlapping header) -->
      <div class="px-5 -mt-10 relative z-10">
        <div class="w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600
                    flex items-center justify-center text-white text-2xl font-bold
                    shadow-lg border-4 border-white">
          {{ formProfile.firstName?.charAt(0) || '?' }}{{ formProfile.name?.charAt(0) || '?' }}
        </div>
      </div>

      <!-- User Info -->
      <div class="px-5 pt-3 pb-5">
        <h2 class="text-lg font-bold text-gray-900">{{ formProfile.firstName }} {{ formProfile.name }}</h2>
        <p class="text-sm text-gray-500 mt-0.5 flex items-center gap-1.5">
          <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
          {{ formProfile.email }}
        </p>
        @if(formProfile.phone) {
          <p class="text-sm text-gray-500 mt-1 flex items-center gap-1.5">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
            </svg>
            {{ formProfile.phone }}
          </p>
        }

        <!-- Role Badge -->
        @if(employee.role) {
          <div class="mt-4 pt-4 border-t border-gray-100">
            <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-lg"
                  [ngClass]="employee.role === 'ADMIN' || employee.role === 'SUPERADMIN' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-600'">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                @if(employee.role === 'ADMIN' || employee.role === 'SUPERADMIN') {
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                } @else {
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                }
              </svg>
              {{ employee.role === 'SUPERADMIN' ? 'Super Admin' : (employee.role === 'ADMIN' ? 'Administrator' : 'Member') }}
            </span>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Right: Editable Information -->
  <div class="flex-1">
    <!-- Personal Information Card -->
    <div class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
      <div class="px-6 py-4 border-b border-gray-100 bg-gray-50/80 flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center">
            <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
            </svg>
          </div>
          <div>
            <h2 class="text-base font-semibold text-gray-900">Personal Information</h2>
            <p class="text-xs text-gray-500">Update your name and contact details</p>
          </div>
        </div>
        <button (click)="saveProfile()" [disabled]="loadingProfile"
                class="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white
                       bg-blue-600 hover:bg-blue-700
                       disabled:opacity-50 transition-all cursor-pointer
                       focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
          @if(loadingProfile) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>Saving...</span>
          } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
            <span>Save Changes</span>
          }
        </button>
      </div>
      <div class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1.5">First Name</label>
            <input type="text" [(ngModel)]="formProfile.firstName"
                   class="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                          focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                          hover:border-gray-400 transition-colors outline-none"
                   placeholder="Enter your first name">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1.5">Last Name</label>
            <input type="text" [(ngModel)]="formProfile.name"
                   class="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                          focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                          hover:border-gray-400 transition-colors outline-none"
                   placeholder="Enter your last name">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1.5">Phone Number</label>
            <input type="tel" [(ngModel)]="formProfile.phone"
                   class="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                          focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                          hover:border-gray-400 transition-colors outline-none"
                   placeholder="+1 (555) 000-0000">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1.5">
              Email Address
              <span class="text-xs text-gray-400 font-normal ml-1">(read-only)</span>
            </label>
            <div class="relative">
              <input type="email" [(ngModel)]="formProfile.email"
                     class="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm
                            bg-gray-50 text-gray-500 cursor-not-allowed pr-10"
                     readonly>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
} @else {
<!-- Loading State -->
<div class="flex flex-col items-center justify-center py-20 bg-white rounded-2xl border border-gray-200 shadow-sm">
  <div class="w-12 h-12 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin mb-4"></div>
  <p class="text-gray-600 font-medium">Loading your profile...</p>
  <p class="text-sm text-gray-400 mt-1">Please wait a moment</p>
</div>
}
